import { render, staticRenderFns } from "./desktop.vue?vue&type=template&id=7ce07b9c&scoped=true"
import script from "./desktop.vue?vue&type=script&lang=js"
export * from "./desktop.vue?vue&type=script&lang=js"
import style0 from "./desktop.vue?vue&type=style&index=0&id=7ce07b9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce07b9c",
  null
  
)

export default component.exports